import React from 'react';

const btn = {
    background:
      "#7821A0 0% 0% no-repeat padding-box",
    boxShadow: "0px 10px 20px #6A00FF73",
    borderRadius: "27px",
    opacity: "1",
    color: "#FFFFFF",
    padding: "8px",
    minWidth: "190px",
    minHeight: "40px",
    borderWidth: "thin",
  
  };
const EmpleosGuardados = () => {
    return (
        <div className="row ml-4">
            <div className="col-md-12 p-0">
                <div className="text-center mt-4 p-0">
                    <button style={btn}>Empleos Guardados</button>
                </div>
            </div>
        </div>
    );
}

export default EmpleosGuardados;
